import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { Fragment, useMemo } from 'react';
import { FONT_SIZES } from '../styles.contants';
import StyleButtonWithDropdown from '../styleButton/StyleButtonWithDropdown';
var FontSizeControl = function FontSizeControl(_ref) {
  var control = _ref.control,
    editorState = _ref.editorState,
    onToggle = _ref.onToggle,
    styles = _ref.styles;
  var fontSize = styles.fontSize.current(editorState);
  var fontSizes = useMemo(function () {
    return FONT_SIZES.map(function (fs) {
      return _objectSpread(_objectSpread({}, fs), {}, {
        render: function render() {
          return /*#__PURE__*/React.createElement("span", {
            style: {
              fontSize: fs.value
            }
          }, " ", fs.name, " ");
        }
      });
    }, []);
  });
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(StyleButtonWithDropdown, {
    key: control.label,
    active: false,
    label: control.label,
    onClick: function onClick(size) {
      return onToggle(size);
    },
    style: control.style,
    icon: control.icon,
    items: fontSizes,
    activeItem: fontSize
  }));
};
export default FontSizeControl;